import { ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Footer, Header, ModalBody, ModalContainer, ModalRoot, WeModalCloseIcon } from './styles';

import Icon from '@components/Icon';
import { useTheme } from 'styled-components';

interface WeModalProps {
  visible: boolean;
  onClose: () => void;
  children: ReactNode;
  backgroundColor: string;
  width: string;
  maxHeight?: string;
  maxHeightModalBody?: string;
  header?: ReactNode;
  footer?: ReactNode;
}
const WeModal = ({
  visible,
  onClose,
  children,
  maxHeight,
  maxHeightModalBody = '75vh',
  width,
  header,
  footer,
  backgroundColor,
}: WeModalProps) => {
  const theme = useTheme();
  const componentRef = useRef<HTMLInputElement | null>(null);

  const stopPropagation = (e: Pick<Event, 'stopPropagation'>) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible]);

  useEffect(() => {
    const element = componentRef.current;
    setInterval(() => {
      if (visible && element && element.scrollTop !== 0) {
        element.scrollTop = 0;
      }
    }, 500);
  }, [visible]);

  const modalContent = (
    <ModalRoot $mounted={visible} ref={componentRef}>
      <ModalContainer
        onClick={stopPropagation}
        $backgroundColor={backgroundColor}
        $width={width}
        $maxHeight={maxHeight}
      >
        <Header>{header && <>{header}</>}</Header>
        <ModalBody maxHeightModalBody={maxHeightModalBody}>
          {children}
        </ModalBody>
        <div>{footer && <Footer>{footer}</Footer>}</div>
        <WeModalCloseIcon onClick={onClose}>
          <Icon
            size={35}
            color={theme.color.shadeGrey2}
            indentLess
            name="close"
            $hoverEffect
          />
        </WeModalCloseIcon>
      </ModalContainer>
    </ModalRoot>
  );

  // Use Portal to render modal at document body level
  // Check if document.body exists (for SSR compatibility)
  if (!visible || typeof document === 'undefined' || !document.body) {
    return null;
  }

  return createPortal(modalContent, document.body);
};

export default WeModal;
